import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Quick Button
 */
const ListButtonDescription = ({ boxStyle, item, viewType,  }) => {
  const { items, id, type } = item;
  // console.log(items)
  return (
    <>
      <div className="_list_button_description_div" style={boxStyle} >
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
            <div className="_list_button_description_area" key={`${id}_${idx}_area`}>
                {ReactHtmlParser(tempItem?.text?.desc || '')}
            </div>
          );
        })}
      </div>
    </>
  );
};
ListButtonDescription.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
ListButtonDescription.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default ListButtonDescription;
